<app-menu-toggle
  tooltip="Eta-phi energy map"
  icon="eta-phi"
  [active]="showPanel"
  (click)="toggleOverlay()"
>
</app-menu-toggle>
